import { API_URL_NEWS } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";

const deleteNews = (uuid: string) =>
  apiInstance({
    url: API_URL_NEWS + uuid,
    method: "delete",
  });

export default deleteNews;
